function initBackToTopButton () {
  const buttonElements = document.querySelectorAll('.button-back-to-top__container')

  buttonElements.forEach(button => {
    button.addEventListener('click', () => {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    })
  })
}

document.addEventListener('DOMContentLoaded', initBackToTopButton)
